type PromiseWithTry = PromiseConstructor & {
  try?: (fn: (...args: any[]) => unknown, ...args: any[]) => Promise<unknown>;
};

type MapWithUpsert = Map<unknown, unknown> & {
  getOrInsertComputed?: (key: unknown, callback: (key: unknown) => unknown) => unknown;
};

/** Zone.js remplace Promise et perd Promise.try, que pdf.js 5 appelle. */
export function installPromiseTry(Ctor: PromiseConstructor = Promise): void {
  const target = Ctor as PromiseWithTry;
  if (typeof target.try === 'function') return;
  target.try = function (fn, ...args) {
    return new target((resolve) => {
      resolve(fn(...args));
    });
  };
}

/** pdf.js 5.7 appelle cette méthode de Map, absente de Chrome 144. */
export function installMapUpsert(mapPrototype: object = Map.prototype): void {
  const target = mapPrototype as MapWithUpsert;
  if (typeof target.getOrInsertComputed === 'function') return;
  target.getOrInsertComputed = function (key, callback) {
    if (this.has(key)) return this.get(key);
    const value = callback(key);
    this.set(key, value);
    return value;
  };
}
